import { defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Container } from '../container';

const animateLayoutChanges = (args) =>
	defaultAnimateLayoutChanges({ ...args, wasDragging: true });

export function DroppableContainer({
	id,
	label,
	items,
	children,
	style,
	showAddButton,
	...props
}) {
	const {
		active,
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transition,
		transform,
		handleAdd,
	} = useSortable({
		id,
		data: {
			type: 'container',
			children: items,
		},
		animateLayoutChanges,
	});
	const isOverContainer = active ? items.includes(active.id) : false;

	return (
		<Container
			ref={setNodeRef}
			label={label}
			style={{
				...style,
				transition,
				transform: CSS.Translate.toString(transform),
				opacity: isDragging ? 0.5 : undefined,
			}}
			hover={isOverContainer}
			handleProps={{
				...attributes,
				...listeners,
			}}
			showAddButton={showAddButton}
			handleAdd={handleAdd}
			{...props}
		>
			{children}
		</Container>
	);
}
